function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Social_Media_Small_Dark_Facebook-2",
  "data-name": "Social Media / Small / Dark / Facebook",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Combined_Shape",
  "data-name": "Combined Shape",
  d: "M16.383,32.765A16.383,16.383,0,1,1,32.765,16.383,16.4,16.4,0,0,1,16.383,32.765ZM11.042,13.26v3.764h2.106v10.71h4.43V17.024H20.5l.386-3.76h-3.31V11.048a.905.905,0,0,1,.94-1.026H20.9V6.369l-3.28-.013a4.155,4.155,0,0,0-4.47,4.468V13.26Z",
  fill: "#fff"
}));

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Social_Media_Small_Dark_Facebook",
    "data-name": "Social Media / Small / Dark / Facebook",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Facebook.c50f64e8.svg";
export { ForwardRef as ReactComponent };